import { Box, Link, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { DateTime } from "luxon";

const colors = {
  confirmed: "#43A047",
  awaiting: "#FFB920",
  no_event: "gray",
};

export enum EventType {
  CONFIRMED = "confirmed",
  AWAITING = "awaiting",
  NO_EVENT = "no_event",
}

export function TimelineItem({
  label,
  date,
  type,
  url,
  isLast,
}: {
  label: string;
  date?: DateTime | string | undefined;
  type: EventType;
  url?: string;
  isLast?: boolean;
}) {
  return (
    <Box sx={{ display: "flex", gap: 1.5, position: "relative", pb: isLast ? 0 : 2 }}>
      {!isLast && (
        <Box
          sx={{
            position: "absolute",
            left: 5,
            top: 14,
            bottom: 0,
            width: "2px",
            backgroundColor: "#D2D2D2",
          }}
        />
      )}
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: colors[type],
          mt: 0.5,
          flexShrink: 0,
          zIndex: 1,
        }}
      />
      <Box>
        <Typography fontWeight={600} sx={{ fontSize: 14 }}>
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
          {typeof date === "string" ? date : (date?.toLocaleString(DateTime.DATETIME_MED, { locale: "en-US" }) ?? "—")}
        </Typography>
        {url && type !== EventType.NO_EVENT && (
          <Link
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: 13, display: "inline-flex", alignItems: "center", gap: 0.5 }}
          >
            Hermes portal
            <OpenInNewIcon sx={{ fontSize: 14 }} />
          </Link>
        )}
      </Box>
    </Box>
  );
}

export function Timeline({
  events,
}: {
  events: { eventName: string; date: DateTime | string | undefined; type: EventType; url?: string }[];
}) {
  return (
    <Box sx={{ mb: 2.5 }}>
      {events.map((event, index) => (
        <TimelineItem
          key={event.eventName}
          label={event.eventName}
          date={event.date}
          type={event.type}
          url={event.url}
          isLast={index === events.length - 1}
        />
      ))}
    </Box>
  );
}
